import React from 'react';
import { DBLeftSection, DBRightSection } from '../components';
import { useSelector } from 'react-redux';
import NotFoundPage from '../components/NotFoundPage';

const Dashboard = () => {
  const user = useSelector(state => state.user);

  return (
    user && (user.role === "admin" || user.role === "moderator") ? (
      <div className='w-screen h-screen items-center bg-primary flex'>
        <DBLeftSection />
        <DBRightSection />
      </div>
    ) : (
      <NotFoundPage /> // Use the NotFoundPage component here
    )
  );
};

export default Dashboard;
